// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__QP-QX","right":"styles_right__51Pk_"};